import { Component, EventEmitter, inject, Output } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { TranslateModule } from '@ngx-translate/core';
import { OVERLAY_DATA } from 'src/app/shared/services/dynamic-overlay/dynamic-overlay.service';

export interface SelectListItem {
  label: string;
  value: any;
  icon?: string;
}

export interface SelectListData {
  title: string;
  items: SelectListItem[];
  selectedValue: any;
}

@Component({
  selector: 'app-select-list',
  standalone: true,
  imports: [MatListModule, TranslateModule, MatIconModule],
  template: `
    <div class="select-list-container">
      <mat-nav-list>
        @for (item of data.items; track item) {
          <a mat-list-item (click)="select(item.value)" [class.selected]="item.value === data.selectedValue">
            @if (item.icon) {
              <mat-icon matListItemIcon>{{ item.icon }}</mat-icon>
            }
            <span matListItemTitle>{{ item.label | translate }}</span>
          </a>
        }
      </mat-nav-list>
    </div>
  `,
  styleUrls: ['./select-list.component.scss'],
})
export class SelectListComponent {
  @Output() optionSelected = new EventEmitter<any>();
  data: SelectListData = inject(OVERLAY_DATA);

  select(value: any): void {
    this.optionSelected.emit(value);
  }
}
